const palette = {
    primary: {
        main: "#143256",
        light: "#153256",
        dark: "#0F233C",
    },
    secondary: {
        main: "#929292",
    },
    success: {
        main: "#6CB237",
    },
    warning: {
        main: "#FF6900",
    },
    error: {
        main: "#DC001E",
    },
    info: {
        main: "#397CCF",
    },
    black: "#000000",
    white: "#ffffff",
    textDark: "#1D1D1B",
    textGrey: "#5F6368",
    greenSwitch: "#6CB237",
};

const fontFamily = "Barlow";

const typography = {
    fontFamily,
    h1: {
        fontSize: 28,
        fontWeight: 700,
        fontFamily,
        color: palette.primary.main,
        lineHeight: "36px",
        "@media (max-width: 678px)": {
            fontSize: 24,
        },
    },
    h2: {
        fontSize: 26,
        fontWeight: 500,
        fontFamily,
        color: palette.primary.main,
        "@media (max-width: 678px)": {
            fontSize: 22,
        },
    },
    h3: {
        fontSize: 24,
        fontWeight: 300,
        fontFamily,
        color: palette.primary.light,
        "@media (max-width: 678px)": {
            fontSize: 20,
        },
    },
    h4: {
        fontSize: 22,
        fontWeight: 700,
        fontFamily,
        color: palette.textDark,
        "@media (max-width: 678px)": {
            fontSize: 18,
        },
    },
    h5: {
        fontSize: 18,
        fontWeight: 400,
        fontFamily,
        color: palette.textDark,
        "@media (max-width: 678px)": {
            fontSize: 16,
        },
    },
    body1: {
        fontSize: 18,
        fontWeight: 300,
        fontFamily,
        color: palette.black,
        "@media (max-width: 678px)": {
            fontSize: 16,
        },
    },
    body2: {
        fontSize: 18,
        fontWeight: 300,
        fontFamily,
        color: palette.textGrey,
        "@media (max-width: 678px)": {
            fontSize: 16,
        },
    },
    caption: {
        fontSize: 14,
        fontWeight: 400,
        fontFamily,
        color: palette.textGrey,
    },
    subtitle2: {
        fontSize: 16,
        fontWeight: 300,
        fontFamily,
        color: palette.black,
    },
};

export const themeMUI = {
    name: "USPA Student Theme",
    palette,
    typography,
    components: {
        MuiSwitch: {
            styleOverrides: {
                root: {
                    width: 40,
                    height: 20,
                    padding: 0,
                    borderRadius: 10,
                },
                track: {
                    backgroundColor: "#ddd",
                },
                thumb: {
                    width: 18,
                    height: 18,
                    "&:before": {
                        content: "''",
                        position: "absolute",
                        left: 6,
                        top: 3,
                        fontFamily: "arial",
                        fontSize: 12,
                        transform: "scaleX(-1) rotate(-35deg)",
                    },
                    ".Mui-checked &:before": {
                        content: "'L'",
                        color: palette.greenSwitch,
                        left: 6,
                        top: 0,
                    },
                },
                switchBase: {
                    padding: 0,
                    margin: 1,
                    backgroundColor: palette.white,
                    "&.Mui-checked": {
                        color: palette.white,
                        "&.Mui-disabled": {
                            color: palette.white,
                        },
                        "& + .MuiSwitch-track": {
                            backgroundColor: palette.greenSwitch,
                            opacity: 1,
                        },
                    },
                    "&.Mui-disabled": {
                        opacity: 0.7,
                        "& + .MuiSwitch-track": {
                            opacity: 0.7,
                        },
                    },
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    color: "unset",
                    backgroundColor: "unset",
                    border: "unset",
                    borderRadius: "unset",
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: "unset",
                },
            },
        },
    },
};
